import React, { Fragment, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import DataExplorer from "@nteract/data-explorer";
import PaidByLabs from "./SignUps/paidByLabs"
import DataExplorerContainer from "./DataExplorer/dataExplorerContainer";

const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
  .hide {
	display: none;
  }
  .active {
	display: block;
  }
`;

export default function SignUpsExplorer() {
  const [searchBy, setSearchBy] = useState("dd");
  const currentDate = searchBy === "dd" ? "Daily" : "Weekly";
  const inverseDate = searchBy === "dd" ? "Weekly" : "Daily";
  const handleChange = () => {
	setSearchBy(searchBy === "dd" ? "week" : "dd");
  }

  const data = [{
		title: "By Breakdown",
		query: "byBreakdown",
		explorer: "paidByBreakdown",
		requestType: "paidExplorer"
	},
	// {
	// 	title: "By Device",
	// 	query: "byDevice",
	// 	explorer: "paidByDevice",
	// 	requestType: "paidExplorer"
	// },
	{
		title: "by Source",
		query: "bySource",
		explorer: "paidBySource",
		requestType: "paidExplorer"
	},
	// {
	// 	title: "By Source With Region",
	// 	query: "bySourceWithRegion",
	// 	explorer: "paidByBreakdownWithRegion",
	// 	requestType: "paidExplorer"
	// }
]

  
  return <Container>
    <h1>
        Only paid Sign-ups explorer
    </h1>
	<div>
	<label>Current Time Frame:</label>&nbsp; <span style={{fontSize:"1.2rem"}}>{currentDate}</span> &nbsp; <button onClick={()=> handleChange()}>Change to {inverseDate}</button>
	</div>
	<br/>
	<div className={searchBy === "week" ? "active" : "hide"}>
		{data.map((item, idx) => {
			return (
				<Fragment key={"frag1" + idx}>
						<h2>Weekly {item.title}</h2>
						<DataExplorerContainer
							key={idx + 'week'}
							date={"week"}			
							query={item.query}
							explorer={item.explorer}
							requestType={item.requestType}
						/>
						<hr />
				</Fragment>
			)
		})}
	</div>
	
	<div className={searchBy === "dd" ? "active" : "hide"}>
		{data.map((item, idx) => {
			return (
				<Fragment key={"frag2" + idx}>
					<h2>Daily {item.title}</h2>
					<DataExplorerContainer
						key={idx + 'dd'}
						date={"dd"}					
						query={item.query}
						explorer={item.explorer}
						requestType={item.requestType}
					/>
					<hr />
				</Fragment>
			)
		})}
	</div>

    </Container>
};